'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "years" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/range/years.js
// module id = 1699
// module chunks = 0